module.exports = __webpack_public_path__ + "static/media/estrella.55b37920.png";